export const perHour = 0.01;
export const monthRate = parseFloat(perHour * 24 * 30).toFixed(1);
